'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import { PropTypes } from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import usageTracker from '../../lib/usageTracker';
import { CMS_FREE_SIGNUP_LINK } from '../../constants/TrialConstants';
import { parseUtmParams } from '../../util/Urls';

const handleTrialCTAClick = ({
  websiteUrl
}) => {
  usageTracker.log('trialBannerClick', {
    type: 'dtt-cta-click',
    websiteUrl,
    source: 'trial-cta-sidepanel'
  });
};

const NoCreditCard = () => {
  return /*#__PURE__*/_jsx("span", {
    className: "no-credit-card",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "results.sidePanel.overallGrade.cta.noCreditCard"
    })
  });
};

const CtaButton = ({
  onClick
}) => {
  const parsedUtmParams = parseUtmParams();
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("a", {
      className: "button white",
      target: "_blank",
      rel: "noopener noreferrer",
      href: `${CMS_FREE_SIGNUP_LINK}&${parsedUtmParams}`,
      onClick: onClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "trialBanner.ctaCmsFreeButton"
      })
    }), /*#__PURE__*/_jsx(NoCreditCard, {})]
  });
};

const TrialCta = ({
  websiteUrl
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: "cta-section",
    children: [/*#__PURE__*/_jsx("div", {
      className: "cta-title",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "results.sidePanel.overallGrade.cta.title"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "cta-microcopy",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "results.sidePanel.overallGrade.cta.microcopy"
      })
    }), /*#__PURE__*/_jsx(CtaButton, {
      onClick: () => handleTrialCTAClick({
        websiteUrl
      })
    })]
  });
};

TrialCta.propTypes = {
  websiteUrl: PropTypes.string.isRequired
};
export default TrialCta;